"use client";

import { useEffect } from "react";
import { trackNavigationClick } from "./navigation-click-tracking";

/** Tracks clicks on every Contentful menu entry of the header and footer. */
export function NavigationClickTracker() {
  useEffect(() => {
    // Capture phase: menus close and unmount their links on click.
    const handleClick = (event: MouseEvent) =>
      trackNavigationClick(event.target);
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
}
